(function ($) {
    function gdprCustomScroll() {
        setTimeout(function() {
            $('.moove-gdpr-tab-main-content').each(function(index, el) {
                new SimpleBar($(this)[0]);
            })
        }, 1)
    }

    $(document).on('click', '[data-href="#moove_gdpr_cookie_modal"]', gdprCustomScroll);
})(jQuery);